import { WPAPIEndpoint } from '@/globalVariables';
import { MLSListing } from '@/utils/types/MLSListing';

const lmMLSListing: ( listingID: number ) => Promise<MLSListing> = async ( listingID ): Promise<MLSListing> => {
    try {
        const mlsListingEndpoint: string = `${WPAPIEndpoint}/mls-listing/?listingID=${listingID}`;
        
        if ( window.lmEnv !== 'prod' ) {
            console.log( 'lmMLSListing ' + mlsListingEndpoint );
        }

        const response: Response = await fetch( mlsListingEndpoint );
        const result: MLSListing = await response.json();

        return result;

    } catch ( error ) {
        console.error( 'Error fetching mls results: ', error );
        throw error;
    }
}
export default lmMLSListing;